import React, { useState, useCallback } from 'react';
import NotificationContext from './NotificationContext';
import NotificationContainer from './NotificationContainer';

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    const addNotification = useCallback((type, message, duration = 3000) => {
        const id = Math.random().toString(36).substr(2, 9);
        setNotifications(prev => [...prev, { id, type, message, duration }]);
    }, []);

    const removeNotification = useCallback((id) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    }, []);

    const contextValue = {
        addNotification,
        removeNotification,
        success: (msg, duration) => addNotification('success', msg, duration),
        error: (msg, duration) => addNotification('error', msg, duration),
        info: (msg, duration) => addNotification('info', msg, duration)
    };

    return (
        <NotificationContext.Provider value={contextValue}>
            {children}
            <NotificationContainer
                notifications={notifications}
                removeNotification={removeNotification}
            />
        </NotificationContext.Provider>
    );
};
